export const TOAST_CLOSE_TIME = 6000;
